
import ModalEducateUsers from '@marketplace/components/modals/modal-educate-users.vue'

export default {
    name: 'ModalReachCustomerService',

    components: {
        ModalEducateUsers,
    },

    data() {
        return {
            steps: [
                {
                    title: `${this.$t('labels.reach_customer_service')}`,

                    backgroundColor: '#DDB254',
                    imageUrl:
                        require('~assets/images/user-education/reach-us-anytime.svg'),
                    extraContent: [
                        {
                            iconClass: 'far fa-envelope ',
                            text: this.$t('labels.email_us_at'),
                        },
                        {
                            iconClass: 'far fa-question mr-1',
                            text: this.$t('labels.visit_help_center'),
                        },
                        {
                            iconClass: 'far fa-comment ',
                            text: this.$t('labels.quick_reply_chat'),
                        },
                        {
                            iconClass: 'far fa-phone rotate-90',
                            text: this.$t('labels.call_us_on'),
                        },
                    ],
                    isCustomerService: true,
                },
            ],
        }
    },
}
